import {createApp} from 'vue'
import CreateFrivilligeProfile from './CreateFrivilligeProfile'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--create-frivillige-profile'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateFrivilligeProfileDOM)=>{
            const props = handleComponentProps(CreateFrivilligeProfile, CreateFrivilligeProfileDOM)
            const component = createApp(CreateFrivilligeProfile, props).use(Store)
            component.mount(CreateFrivilligeProfileDOM)
        })
    }
}